import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const StartStep: React.FC = () => {
  const { goNext } = useWizard();
  const [title, setTitle] = useState('Ansøg om pas');
  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.start).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  return (
    <StepContainer title={title}>
      {body ? <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox> : (
        <p>Denne guide hjælper dig gennem processen med at ansøge om nyt pas.</p>
      )}
      <NavigationButtons onNext={goNext} showBack={false} nextText="Start ansøgning" />
    </StepContainer>
  );
};

export default StartStep;
